/* Mount Shopify's original buttons when they can be used, not during first paint. */
(() => {
  if (customElements.get('mmlc-shop-on-demand')) return;
  class ShopOnDemand extends HTMLElement {
    connectedCallback() {
      if (this.started || this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const activate = () => this.activate();
      if (this.hasAttribute('data-account')) {
        const account = this.closest('.header-customer-accounts') || this.closest('header-drawer') || this.parentElement;
        account.addEventListener('pointerenter', activate, options);
        account.addEventListener('pointerdown', activate, options);
        account.addEventListener('focusin', activate, options);
      } else if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.activate();
        }, {rootMargin:'200px'});
        this.observer.observe(this);
        this.addEventListener('focusin', activate, options);
      } else {
        this.activate();
      }
    }
    activate() {
      const template = this.querySelector('template');
      if (this.started || !template) return;
      this.started = true;
      this.observer?.disconnect();
      const content = document.importNode(template.content, true);
      // Explicitly recreate scripts from the trusted, server-rendered Shopify filter.
      // Module URLs are deduplicated by the browser's module cache.
      const scripts = [...content.querySelectorAll('script')].map(source => {
        const script = document.createElement('script');
        for (const attribute of source.attributes) script.setAttribute(attribute.name, attribute.value);
        script.textContent = source.textContent;
        source.remove();
        return script;
      });
      template.replaceWith(content);
      this.append(...scripts);
      this.dataset.loaded = 'true';
      this.abort?.abort();
      this.abort = null;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  }
  customElements.define('mmlc-shop-on-demand', ShopOnDemand);
})();
